import { __assign, __extends, __rest } from "tslib";
import React from 'react';
var withStylableSupport = function (Component, compClassName) {
    return /** @class */ (function (_super) {
        __extends(WithStylableSupport, _super);
        function WithStylableSupport() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        WithStylableSupport.prototype.render = function () {
            var _a = this.props, internalOrExternal = _a.internalOrExternal, props = __rest(_a, ["internalOrExternal"]);
            return (React.createElement("div", { style: { width: '100%' }, className: "".concat(compClassName, "-").concat(internalOrExternal) },
                React.createElement(Component, __assign({}, props))));
        };
        return WithStylableSupport;
    }(React.Component));
};
export default withStylableSupport;
//# sourceMappingURL=withStylableSupport.js.map